export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-brands-400.ttf?5818bbd07dfd7095920a592049f5d9bd";